"use client";

import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Collaboration() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    number: "12+",
    label: "Anni di Esperienza"
  }, {
    number: "85",
    label: "Progetti Completati"
  }, {
    number: "2024",
    label: "Portfolio Attivo"
  }];
  return <section data-section-id="2182" id="ready-to-collaborate" className="relative bg-background text-foreground overflow-hidden py-24 md:py-32 lg:py-[140px] px-6 md:px-10 lg:px-16">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {}
          <div ref={textRef} data-index={0} className="lg:col-span-7 transition-all duration-[800ms] ease-out" style={{
          opacity: textVisible ? 1 : 0,
          transform: textVisible ? "translateY(0)" : "translateY(24px)"
        }}>
            <p className="font-default text-xs md:text-sm uppercase tracking-[0.2em] mb-8 text-primary">
              Costruiamo insieme
            </p>

            <h2 className="font-default font-bold leading-[1.1] mb-4 text-4xl md:text-5xl lg:text-6xl xl:text-[72px] text-foreground">
              Vuoi essere ospite
              <br />
              di una puntata?
            </h2>

            <p className="uppercase tracking-wider mb-10 text-muted-foreground !font-semibold !text-3xl !font-mono"><span className="!text-lg">O vuoi supportare questo progetto?</span></p>

            <p className="font-default text-base md:text-lg leading-relaxed max-w-[480px] mb-10 text-muted-foreground">Scopriamo come possiamo elevare la presenza digitale del tuo brand.</p>

            <div className="flex flex-col sm:flex-row gap-6 sm:items-center">
              <Button asChild size="lg" className="font-default text-base px-8 h-14 rounded-lg shadow-md hover:shadow-lg transition-shadow bg-primary text-primary-foreground">
                <Link to="/HomePage">Hai una storia da raccontare? Scrivimi.</Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="font-default text-base px-8 h-14 rounded-lg border-primary text-primary hover:bg-primary/10">
                <Link to="/HomePage" className="inline-flex items-center gap-2">
                  <span>Vorrei supportare il progetto</span>
                  <ArrowUpRight className="size-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative">
            <div ref={imageRef} data-index={1} className="relative transition-all duration-[800ms] ease-out" style={{
            opacity: imageVisible ? 1 : 0,
            transform: imageVisible ? "translateY(0)" : "translateY(24px)"
          }}>
              <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg border border-border">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/design_studio_workspace.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/design_studio_workspace.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/design_studio_workspace.webp-wvc-sizes" alt="Modern design studio workspace with high-end equipment" loading="lazy" decoding="async" className="w-full h-full object-cover" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/Post-Instagram-Carosello-Marketing-Aziendale-Minimalista-Moderno-Bianco-A5-orizzontale.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/LOGO-LIONIA-PROJECT.png" src="https://lioniaproject.com/wp-content/uploads/2026/06/cropped-20250519_1558_Lioness-at-Dawn_simple_compose_01jvmdbm9fesptmdccdgpy5hgf-1-2.png" />
              </div>

              {}
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}